// i18n
import { i18n } from '@ecg-marktplaats/js-react-i18n';
import { nl as dateLocale } from 'date-fns/locale/nl';
import translation from '../../../../locales/nl-BE/translation.json';
import common from '../../../../locales/nl-BE/common.json';
import priceTypes from '../../../../locales/nl-BE/priceTypes.json';

export default i18n.init({
  lng: 'nl-BE',
  translations: {
    translation,
    common,
    priceTypes,
  },
  dateLocale,
});
